module.exports = __webpack_public_path__ + "544758e3a33e179e2322ed93f64cf0b2.pdf";